import { render, staticRenderFns } from "./CampaignPointsTable.vue?vue&type=template&id=676a7f50&"
import script from "./CampaignPointsTable.vue?vue&type=script&lang=js&"
export * from "./CampaignPointsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports